import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const textVerticalFn = /* @__PURE__ */ createRecipe('text-vertical', {}, [])

const textVerticalVariantMap = {}

const textVerticalVariantKeys = Object.keys(textVerticalVariantMap)

export const textVertical = /* @__PURE__ */ Object.assign(memo(textVerticalFn.recipeFn), {
  __recipe__: true,
  __name__: 'textVertical',
  __getCompoundVariantCss__: textVerticalFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: textVerticalVariantKeys,
  variantMap: textVerticalVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, textVerticalVariantKeys)
  },
  getVariantProps: textVerticalFn.getVariantProps,
})